import { render, staticRenderFns } from "./ResearchInnovationReviewer.vue?vue&type=template&id=e7514580&"
import script from "./ResearchInnovationReviewer.vue?vue&type=script&lang=js&"
export * from "./ResearchInnovationReviewer.vue?vue&type=script&lang=js&"
import style0 from "./ResearchInnovationReviewer.vue?vue&type=style&index=0&id=e7514580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports